var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"more"},[_vm._v(_vm._s(_vm.text || "更多")),_c('img',{staticClass:"icon-right",attrs:{"src":require("../assets/arrow_right.png"),"alt":""}})])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2b1869fd","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./~/vux-loader/src/before-template-compiler-loader.js!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/More.vue
// module id = 1500
// module chunks = 0